module.exports = __webpack_public_path__ + "static/media/lektorska_cinnost.43337424.svg";